<template>
    <div class="footer-container">
        <div class="footer-content">
            <div class="footer-left">
                <img :src="FooterLogo" alt="Privacy Bee Admin Footer Logo" class="logo" />
                <span>2025 Privacy Bee, LLC. All-rights Reserved.</span>
            </div>
            <div class="footer-right">
                <span>Privacy Policy</span>
                <div class="divider">|</div>
                <span>Legal</span>
                <div class="divider">|</div>
                <span>Support</span>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import FooterLogo from '@/assets/images/admin/footer-logo.png';
</script>
<style scoped lang="scss">
.footer-container {
    @apply flex flex-col justify-center items-center shrink-0 border-t border-border-gray h-20;

    .footer-content {
        @apply flex justify-between items-center self-stretch px-6;
        .footer-left {
            @apply flex items-center gap-4 self-stretch;

            span {
                @apply flex items-center gap-4 self-stretch text-zinc-400 font-inter text-xs font-normal leading-normal;
            }
        }

        .footer-right {
            @apply flex items-center gap-4 self-stretch;

            span {
                @apply flex items-center gap-4 self-stretch text-zinc-800 font-inter text-xs font-normal leading-normal;
            }

            .divider {
                 @apply text-xs font-normal font-inter leading-normal text-border-gray;
            }
        }
    }
}
</style>
